function toggleHiddenPanel(randomId, clickedDiv) {
    var hiddenPanelContent = document.getElementById(randomId);
    var expandable = clickedDiv.querySelector('.expandable');

    if (hiddenPanelContent.classList.contains("visible")) {
        hiddenPanelContent.classList.remove("visible");
    }
    else {
        hiddenPanelContent.classList.add("visible");
    }

    if (expandable.classList.contains("active")) {
        expandable.classList.remove("active");
    }
    else {
        expandable.classList.add("active");
    }
}